import React from 'react';

import { Panel, PanelHeader, PanelHeaderBack } from '@vkontakte/vkui';
import { useSelector } from 'react-redux';

import { SearchFriendPanelProps } from './types';
import { HeaderContent } from '../../../../components/HeaderContent';
import { useRouter } from '../../../../hooks/useRouter';
import { selectIsDesktop } from '../../../../store/settingsSlice/settingsSelectors';
import { SearchFriendPage } from '../../pages/SearchFriendPage';

export const SearchFriendPanel: React.FC<SearchFriendPanelProps> = ({ id }) => {
  const isDesktop = useSelector(selectIsDesktop);
  const router = useRouter();
  const onBackClick = router.back;

  return (
    <Panel id={id}>
      <PanelHeader
        separator={isDesktop}
        before={
          isDesktop ? (
            <PanelHeaderBack onClick={onBackClick} />
          ) : (
            <HeaderContent needBackIcon title="Поиск" onClick={onBackClick} />
          )
        }
      >
        {isDesktop && 'Поиск'}
      </PanelHeader>
      <SearchFriendPage id={id}/>
    </Panel>
  );
};
